import { createContext } from 'react';

const DeviceContext = createContext(null);

export default DeviceContext;
